const apiBase = process.env.REACT_APP_ZOOM_API_BASE || '';

async function handleResponse(res) {
  let payload = {};
  try {
    payload = await res.json();
  } catch {
    payload = {};
  }
  if (!res.ok) {
    throw new Error(payload?.error || 'Request failed.');
  }
  return payload;
}

/**
 * Create a class or demo meeting.
 *
 * Class:  { type: 'class', mentorId, studentId, scheduledAt, duration?, title?, notes? }
 * Demo:   { type: 'demo',  mentorId, studentId, salesPersonId, scheduledAt, duration?, title?, notes? }
 */
export async function createMeeting(payload) {
  const res = await fetch(`${apiBase}/api/meetings`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  return handleResponse(res);
}

/**
 * Fetch upcoming (scheduled + live) meetings for a user.
 * Returns meetings the user is a participant in, sorted by scheduledAt.
 */
export async function getUpcomingMeetings(userId) {
  if (!userId) return { meetings: [] };
  const res = await fetch(`${apiBase}/api/meetings/upcoming/${userId}`);
  return handleResponse(res);
}
